import { Row, Col } from 'react-bootstrap';
import './SocialItems.css'

export default function SocialItems() {
    return <Row>
        <Col xs={3}>
            <a href="https://www.facebook.com/assembleiape" className="social-link social-facebook"></a>
        </Col>
        <Col xs={3}>
            <a href="https://www.twitter.com/alepeoficial" className="social-link social-twitter"></a>
        </Col>
        <Col xs={3}>
            <a href="https://www.instagram.com/assembleiape" className="social-link social-instagram"></a>
        </Col>
        <Col xs={3}>
            <a href="https://youtube.com/@assembleiape" className="social-link social-youtube"></a>
        </Col>
    </Row>
}